import BookScreen from "./Components/BookScreen";
import LocationSelection from "./Components/LocationSelection";
import ResourceSelection from "./Components/ResourceSelection";
import BookingProcess from "./Components/BookingProcess";
import GroupTherapyProcess from "./Components/GroupTherapyProcess";
import colors from "./Themes/Colors";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";

const theme = createMuiTheme({
  typography: {
    fontFamily: ["Open Sans", "sans-serif"].join(","),
  },
  palette: {
    secondary: {
      main: colors.secondary,
    },
    primary: {
      main: colors.primary,
    },
  },
});

const App = () => {
  return (
    <Router>
      <MuiThemeProvider theme={theme}>
         <Route path="/bookappt/:accountId/:mode?/:referralId?/:locName?/:locationId?/:resourceId?/:resourceName?/:firstName?/:lastName?/:DOB?/:cellNo?/:email?/:referralType?/:patientId?/:showSpecialtyQuestions?/:schResourceDoctorId?" component={BookingProcess} />
        <Route path="/grouptherapy/:accountId" component={GroupTherapyProcess} />
      </MuiThemeProvider>
    </Router>
  );
};

export default App;
